export default (state = {}, action) => {

    switch (action.type) {

        case 'GETTING_PCO_EVENTS':
            return Object.assign({},state,{
                ui: action.payload.ui
            })
        case 'GET_PCO_EVENTS_SUCCESS':
            return Object.assign({},state,{
                ui: action.payload.ui,
                events: action.payload.events
            })
        case 'GET_PCO_EVENTS_ERROR':
            return Object.assign({},state,{
                ui: action.payload.ui,
                message: action.payload.message
            })
        default:
            return state
    }
}
